export const isSafari = (): boolean => {
  if (typeof document !== "undefined" && typeof window !== "undefined") {
    return /^((?!chrome|android).)*safari/i.test(window.navigator.userAgent);
  }

  return false;
};
